import * as styles from './heading.css';

import classNames from 'classnames';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface HeadingArgs {
  center?: boolean;
  children?: ReactNode;
  className?: string;
  eyebrowClassName?: string;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
}

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4';

function Heading({
  children,
  center = false,
  className,
  level = 3,
  eyebrowClassName = styles.eyebrow,
}: HeadingArgs) {
  const Tag = `h${level}` as HeadingTag;
  const classes = twMerge(classNames([{ 'text-center': center }]), className) || null;

  if (!children) {
    return null;
  } else if (typeof children === 'string' && children.includes(' ^ ')) {
    const [eyebrow, afterEyebrow] = children.split(/\s+\^\s+/);
    return (
      <Tag className={classes}>
        <span className={eyebrowClassName}>{eyebrow}</span>
        {afterEyebrow}
      </Tag>
    );
  } else {
    return <Tag className={classes}>{children}</Tag>;
  }
}

export default Heading;
